import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { Home, LineChart, Store, BarChart3, User } from "lucide-react";

const MobileNav = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const location = useLocation();

  // Only show bottom nav for logged-in users
  if (!user) return null;

  const items = [
    { to: "/", label: t.nav.home, icon: Home, testid: "mobnav-home" },
    { to: "/mandi", label: t.nav.mandi_short, icon: LineChart, testid: "mobnav-mandi" },
    { to: "/trade", label: t.nav.trade_short, icon: Store, testid: "mobnav-trade" },
    { to: "/analytics", label: t.nav.analytics, icon: BarChart3, testid: "mobnav-analytics" },
    { to: "/profile", label: t.nav.profile, icon: User, testid: "mobnav-profile" },
  ];

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-stone-200 pb-safe"
    >
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          const active = isActive(it.to);
          return (
            <Link
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={`flex flex-col items-center justify-center gap-0.5 py-2.5 px-1 text-[10px] sm:text-[11px] font-medium transition-colors ${
                active ? "text-[#1E4D2B]" : "text-stone-500"
              }`}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 2} />
              <span className="text-center leading-tight break-words w-full">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
